module.exports = __webpack_public_path__ + "img/guide_4_3.8e6a2635.svg";